import React, { useEffect } from 'react'
import './index.css'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

const NotificationComponent = () => {
  const apps = useSelector(state => state.apps)

  const dispatch = useDispatch()

  const duration = 5

  useEffect(
    () => {
      const timer = setTimeout(() => {
        if (apps.notification_type !== 'info') {
          dispatch({
            type: 'apps/RESET_NOTIFICATION',
          })
        }
      }, duration * 1000)

      // this will clear Timeout
      // when component unmount like in willComponentUnmount
      // and show will not change to true
      return () => {
        clearTimeout(timer)
      }
    },
    // useEffect will run only one time with empty []
    // if you pass a value to array,
    // like this - [data]
    // than clearTimeout will run every time
    // this value changes (useEffect re-run)
    [dispatch, apps.notification_message],
  )

  const handleCloseNotification = () => {
    dispatch({
      type: 'apps/RESET_NOTIFICATION',
    })
  }

  const getBackgroundColor = () => {
    if (apps.notification_type === 'success') {
      return 'styleSuccessIcon'
    }
    if (apps.notification_type === 'error') {
      return 'styleFailIcon'
    }
    return 'styleInfoIcon'
  }

  return (
    <>
      {apps.notification_message !== '' ? (
        <div style={{ zIndex: '10' }}>
          <div className="divBox">
            <div className={getBackgroundColor(apps.notification_type)}> </div>
            <div className="divTextNotification">{apps.notification_message}</div>
            <Button onClick={handleCloseNotification} className="buttonCloseNotification">
              <div className="styleCancelIcon" />
            </Button>
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  )
}

export default NotificationComponent
